import React, { ReactNode, FunctionComponent } from 'react'

export interface Props {
  title: ReactNode
  children: ReactNode
  gridClass?: string
  selected?: boolean
}

export const ProductSelectionCard: FunctionComponent<Props> = ({
  title,
  gridClass,
  children,
}) => {
  return (
    <div className={`product-selection-card ${gridClass || null}`}>
      <div className="product-selection-card__header">
        <h2 className="product-selection-card__title">{title}</h2>
      </div>
      <div className="product-selection-card__body">{children}</div>
    </div>
  )
}

ProductSelectionCard.displayName = 'ProductSelectionCard'
